import { createAction, props } from '@ngrx/store';
import { ISetupStatusResponse } from '../../features/todos/models/setup-status.model';

export const loadSetupStatus = createAction('[Shared] Load SetupStatus', props<{ businessId: string | null }>());

export const loadSetupStatusSuccess = createAction(
  '[Shared] Load SetupStatus Success',
  props<{ response: ISetupStatusResponse }>()
);

export const loadSetupStatusFailure = createAction(
  '[Shared] Load SetupStatus Failure',
  props<{ error: Error | any }>()
);
